import { Paper } from '@mui/material';

/**
 * Le tre decisioni che le tabelle di elenco dell'applicazione avevano gia' preso.
 *
 * Tipi di Codex, Gestione prompt, Processi e Code scrivono da sempre la stessa forma:
 * contenitore su carta, righe compatte con una larghezza minima, testata con il fondo
 * appena tinto. Ruoli, permessi e Gruppi sono nati dopo e avevano preso una forma loro —
 * righe piu' alte, testata senza stacco — cosi' che passando da una sezione all'altra la
 * tabella cambiava peso pur dicendo le stesse cose.
 *
 * Stanno qui, e non ricopiate in ogni pagina, perche' e' proprio ricopiandole a mano che
 * la coerenza si era persa.
 */

/**
 * La cornice della tabella: un bordo esplicito, non l'ombra di default.
 *
 * Il fondo della pagina e' bianco come la carta, e l'ombra di `Paper` su bianco si vede o
 * non si vede a seconda dello zoom: nella stessa schermata del dettaglio gruppo il
 * contenuto - che era gia' `outlined` - mostrava una cornice chiusa e i membri no, con
 * l'effetto che alcuni bordi sembravano sparire e altri accentuarsi. Con il bordo la
 * tabella e' una scatola chiusa, e l'ultima riga non e' piu' l'unica linea in fondo.
 *
 * Si usa spalmato: `<TableContainer {...CONTENITORE_TABELLA}>`.
 */
export const CONTENITORE_TABELLA = { component: Paper, variant: 'outlined' };

/** Il fondo della riga di testata: separa le intestazioni dai dati senza una regola in piu'. */
export const TESTATA_TABELLA = { backgroundColor: 'rgba(0, 0, 0, 0.04)' };

/**
 * La larghezza minima di una tabella a tutta pagina. Non si applica alle tabelle dentro una
 * colonna affiancata — il contenuto e i membri di un gruppo — che a 650px scrollerebbero in
 * orizzontale sempre.
 */
export const TABELLA_PAGINA = { minWidth: 650 };
